// removed by extract-text-webpack-plugin
module.exports = {"policy":"_2qFjokt2zEd5lxWxUjgC2P","policyRight":"_3a1rtKmryWcK6lVAuvO1GL","policySidebar":"_3A4iHWlRIu2m8jBSbUpIjU","policySidebarItem":"_2RbepDB1De2UPQENioWByV","sidebarNav":"RlTywC1DLTyeHs7nbuD5b","active":"_1142XaBiRvi2dePuen6vwj"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Policy/Policy.scss
// module id = 1176
// module chunks = 0